import { capitalize } from '../../../unified-player-core/src/utils/capitalize';

// extracts domain name in form of 'unsplash.com'
const domainNameRegEx =
  /^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/;

export const getTitleFromDomain = (link: string | null | undefined) => {
  if (!link) {
    return '';
  }
  const hostname = link && new URL(link)?.hostname;
  const titleFromDomain = hostname?.match(domainNameRegEx)?.[1]?.split('.')[0];

  return capitalize(titleFromDomain ?? '');
};
